export const HIDDEN_PLACEHOLDER = '**** **** **** ****'
